import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ExamContextProvider } from './context/ExamContext';
import Login from './components/Login';
import ExamRoom from './components/ExamRoom';
import StaffDashboard from './components/StaffDashboard';
import Chat from './components/Chat';
import RequireExamToken from './auth/RequireExamToken';
import './App.css';

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ExamContextProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/exam/:roomId" element={<RequireExamToken role="student"><ExamRoom /></RequireExamToken>} />
            <Route path="/staff/:roomId" element={<RequireExamToken role="staff"><StaffDashboard /></RequireExamToken>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Chat />
        </div>
      </ExamContextProvider>
    </Router>
  );
}

export default App;